import React, { useEffect, useState } from "react";
import Sidebar from "../common/Sidebar";
import { Link } from "react-router-dom";
import "../../styles/AdminPropertiesStyles.css";
import API_URL from "../../config";

function AdminProperties() {
  const [propertiesList, setPropertiesList] = useState([]);
  const [propertyFormData, setPropertyFormData] = useState({
    title: "",
    description: "",
    builtArea: "",
    landArea: "",
    location: "",
    bedrooms: "",
    bathrooms: "",
    propertyType: "",
    status: "",
    value: "",
  });
  const [uploadedImages, setUploadedImages] = useState([]);
  const [previewImageList, setPreviewImageList] = useState([]);

  const authToken = localStorage.getItem("adminToken");

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await fetch(`${API_URL}/api/properties`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        const result = await response.json();
        if (result && Array.isArray(result.data)) {
          setPropertiesList(result.data);
        } else {
          console.error("Unexpected data format:", result);
          setPropertiesList([]);
        }
      } catch (err) {
        console.error("Error fetching properties:", err);
      }
    };
    fetchProperties();
  }, [authToken]);

  const handleInputChange = (e) => {
    setPropertyFormData({ ...propertyFormData, [e.target.name]: e.target.value });
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setUploadedImages(files);
    setPreviewImageList(files.map((file) => URL.createObjectURL(file)));
  };

  const reorderUploadedImages = (startIndex, endIndex) => {
    const reorderedImages = Array.from(uploadedImages);
    const [movedImage] = reorderedImages.splice(startIndex, 1);
    reorderedImages.splice(endIndex, 0, movedImage);
    setUploadedImages(reorderedImages);
    setPreviewImageList(reorderedImages.map((file) => URL.createObjectURL(file)));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!propertyFormData.title || !propertyFormData.description || uploadedImages.length === 0) {
      alert("Please complete all required fields.");
      return;
    }

    const formData = new FormData();
    Object.keys(propertyFormData).forEach((key) =>
      formData.append(key, propertyFormData[key])
    );
    uploadedImages.forEach((image) => formData.append("images", image));

    try {
      const response = await fetch(`${API_URL}/api/properties`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        body: formData,
      });
      if (!response.ok) throw new Error("Error creating property");

      const newProperty = await response.json();
      setPropertiesList([...propertiesList, newProperty]);
      setPropertyFormData({
        title: "",
        description: "",
        builtArea: "",
        landArea: "",
        location: "",
        bedrooms: "",
        bathrooms: "",
        propertyType: "",
        status: "",
        value: "",
      });
      setUploadedImages([]);
      setPreviewImageList([]);
    } catch (err) {
      console.error("Error creating property:", err);
      alert("An error occurred while creating the property.");
    }
  };

  const togglePropertyStatus = async (id, isActive) => {
    try {
      const response = await fetch(`${API_URL}/api/properties/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ isActive: !isActive }),
      });
      if (!response.ok) throw new Error("Error updating property status");

      const updatedProperty = await response.json();
      setPropertiesList(
        propertiesList.map((property) =>
          property._id === id ? updatedProperty : property
        )
      );
    } catch (err) {
      console.error("Error updating property status:", err);
    }
  };

  const deleteProperty = async (id) => {
    try {
      const response = await fetch(`${API_URL}/api/properties/${id}`
, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (!response.ok) throw new Error("Error deleting property");

      setPropertiesList(propertiesList.filter((property) => property._id !== id));
    } catch (err) {
      console.error("Error deleting property:", err);
    }
  };

  return (
    <div
      className="properties-page-container"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/adminImages/properties.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="background-overlay"></div>
      <Sidebar />

      <div className="properties-main-content">
        <header className="properties-header">
          <h1>Gestión de Propiedades</h1>
          {/* <Link to="/admin/dashboard" className="btn btn-secondary">
            Volver
          </Link> */}
        </header>
        <hr />

        <h2>Crear Propiedad</h2>
        <form className="row g-3" onSubmit={handleFormSubmit}>
          <div className="col-md-6">
            <label htmlFor="title" className="form-label">
              Título
            </label>
            <input
              type="text"
              className="form-control"
              id="title"
              name="title"
              value={propertyFormData.title}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="description" className="form-label">
              Descripción
            </label>
            <textarea
              className="form-control"
              id="description"
              name="description"
              value={propertyFormData.description}
              onChange={handleInputChange}
              required
            ></textarea>
          </div>
          <div className="col-md-6">
            <label htmlFor="builtArea" className="form-label">
              Área construida
            </label>
            <input
              type="number"
              className="form-control"
              id="builtArea"
              name="builtArea"
              value={propertyFormData.builtArea}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="landArea" className="form-label">
              Área del terreno (opcional)
            </label>
            <input
              type="number"
              className="form-control"
              id="landArea"
              name="landArea"
              value={propertyFormData.landArea}
              onChange={handleInputChange}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="location" className="form-label">
              Ubicación
            </label>
            <input
              type="text"
              className="form-control"
              id="location"
              name="location"
              value={propertyFormData.location}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="bedrooms" className="form-label">
              Alcobas
            </label>
            <input
              type="number"
              className="form-control"
              id="bedrooms"
              name="bedrooms"
              value={propertyFormData.bedrooms}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="bathrooms" className="form-label">
              Baños
            </label>
            <input
              type="number"
              className="form-control"
              id="bathrooms"
              name="bathrooms"
              value={propertyFormData.bathrooms}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="propertyType" className="form-label">
              Tipo de Propiedad
            </label>
            <select
              id="propertyType"
              name="propertyType"
              className="form-select"
              value={propertyFormData.propertyType}
              onChange={handleInputChange}
              required
            >
              <option value="">Seleccione</option>
              <option value="Apartamento">Apartamento</option>
              <option value="Casa">Casa</option>
              <option value="Apartaestudio">Apartaestudio</option>
            </select>
          </div>
          <div className="col-md-6">
            <label htmlFor="status" className="form-label">
              Estado
            </label>
            <select
              id="status"
              name="status"
              className="form-select"
              value={propertyFormData.status}
              onChange={handleInputChange}
              required
            >
              <option value="">Seleccione</option>
              <option value="Venta">Venta</option>
              <option value="Arriendo">Arriendo</option>
            </select>
          </div>
          <div className="col-md-6">
            <label htmlFor="value" className="form-label">
              Valor
            </label>
            <input
              type="number"
              className="form-control"
              id="value"
              name="value"
              value={propertyFormData.value}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="images" className="form-label">
              Imágenes
            </label>
            <input
              type="file"
              className="form-control"
              id="images"
              multiple
              onChange={handleImageUpload}
            />
            <div className="mt-3 d-flex flex-wrap">
              {previewImageList.map((src, idx) => (
                <div key={idx} className="me-2">
                  <img
                    src={src}
                    alt={`Preview ${idx}`}
                    style={{ width: "100px", height: "auto" }}
                  />
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary mt-1"
                    onClick={() => reorderUploadedImages(idx, idx === 0 ? idx : idx - 1)}
                  >
                    ↑
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary mt-1"
                    onClick={() => reorderUploadedImages(idx, idx === uploadedImages.length - 1 ? idx : idx + 1)}
                  >
                    ↓
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="col-12">
            <button type="submit" className="btn btn-primary">
              Crear Propiedad
            </button>
          </div>
        </form>

        <h2 className="mt-5">Listado de Propiedades</h2>
        <ul className="list-group">
          {propertiesList.map((property) => (
            <li
              key={property._id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <span>
                <strong>{property.title}</strong> - {property.location}
              </span>
              <div>
                {property.isActive ? (
                  <button
                    className="btn btn-danger btn-sm me-2"
                    onClick={() => togglePropertyStatus(property._id, property.isActive)}
                  >
                    Deshabilitar
                  </button>
                ) : (
                  <button
                    className="btn btn-success btn-sm me-2"
                    onClick={() => togglePropertyStatus(property._id, property.isActive)}
                  >
                    Habilitar
                  </button>
                )}
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => deleteProperty(property._id)}
                >
                  Eliminar
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default AdminProperties;
